
import { IonButton, IonPage, IonHeader, IonToolbar, IonTitle, IonContent } from '@ionic/vue';
import Config from  '@/assets/Config';
import Contact from '@/model/Contact';

export default  {
  name: 'Tab3',
  components: {  IonButton, IonHeader, IonToolbar, IonTitle, IonContent, IonPage },

  setup(){

    const report = ()=>{
        window.location.href=Config.URL+'/export/'+Contact.phone+'/'+Contact.dni;
    }
    
    const reportDoc = ()=>{
        window.location.href=Config.URL+'/doc/'+Contact.phone+'/'+Contact.dni;
    }

    const out = ()=>{
        Contact.authorized=false;
        Contact.dni='';
        Contact.phone='';
    }

      return {
          report,
          reportDoc,
          out
      }

  }
}
